import {AfterViewInit, Component, Inject, OnDestroy} from '@angular/core';
import {DialogConfig, DialogData} from "../../../shared/interfaces/dialog";
import {Observable} from "rxjs";
import {IframeDialogComponent} from "../data-sources-listing/iframe-dialog/iframe-dialog.component";
import {FormControl} from "@angular/forms";
import {DataSourcesService} from "../../../shared/services/data-sources.service";
import {Serializer} from "../../../shared/interfaces/serializer";
import {AppService} from '../../../shared/services/app.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
  AdloopTrackingSteppedComponent
} from "../configuration/adloop-tracking-stepped/adloop-tracking-stepped.component";
import {AdloopTrackingSteppedPopinConf} from "../configuration/adloop-tracking-stepped/adloop-tracking-stepped.conf";
import {Store} from "@ngrx/store";
import {AppState} from "../../../shared/store/store";
import {
  selectDataSourcesAllLoading
} from "../../../shared/store/dataSourcesAll/dataSourcesAll.selectors";
import {DataSource} from "../../../shared/interfaces/data-source";
import {SpacesService} from "../../../shared/services/spaces.service";
import {AddDataSetUsageStore} from "./add-data-set-usage.store";
import {DataSourceProvider} from "../../../shared/store/dataSourceProviders/dataSourceProviders";

@Component({
  selector: 'app-add-data-set-usage',
  templateUrl: './add-data-set-usage.component.html',
  styleUrls: ['./add-data-set-usage.component.scss'],
  providers: [AddDataSetUsageStore]
})
export class AddDataSetUsageComponent implements AfterViewInit, OnDestroy {
  public dialogOpenIframeConfig: DialogConfig = {
    data:         {
      component: IframeDialogComponent
    },
    width:        '650px',
    height:       '600px',
    disableClose: false
  }

  public searchText: FormControl = new FormControl('');

  public readonly dataSourcesLoading$: Observable<boolean> = this._store.select(selectDataSourcesAllLoading);

  public readonly multipleList$: Observable<Serializer<DataSourceProvider>[]> = this._addDataSetUsageStore.multipleList$;
  public readonly topList$: Observable<Serializer<DataSourceProvider | DataSource>[]> = this._addDataSetUsageStore.topList$;
  public readonly allList$: Observable<Serializer<DataSourceProvider | DataSource>[]> = this._addDataSetUsageStore.allList$;
  public readonly notFoundList$: Observable<Serializer<DataSourceProvider | DataSource>[]> = this._addDataSetUsageStore.notFoundList$;
  public readonly groupedList$: Observable<object[]> = this._addDataSetUsageStore.groupedList$;


  constructor(
    private readonly appS: AppService,
    public readonly dataSourcesS: DataSourcesService,
    private readonly spaceS: SpacesService,
    public readonly dialog: MatDialog,
    public readonly dialogRef: MatDialogRef<AddDataSetUsageComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogData,

    private readonly _store: Store<AppState>,
    private readonly _addDataSetUsageStore: AddDataSetUsageStore,
  ) {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}


  public openModal(dataSource: Serializer<DataSource | any>): void {
    this.dialogRef.close();

    if (dataSource.type === 'data_source_provider') {
      // Opens the iframe
      this.dialog.open(IframeDialogComponent, {
        data: {
          inputData: {
            link: this.appS.datasetID+'/data-source-providers/'+dataSource.id+'/start'
          }
        },
        width: '40vw',
        height: '50vh',
        disableClose: true
      });

    } else if (dataSource.attributes.front_config && ((dataSource.attributes.is_premium && this.appS.isPremium)
      || (dataSource.attributes.is_premium && this.spaceS.isFreePlan(this.appS.space) &&  this.spaceS.isPlanOk(this.appS.space))
      || !dataSource.attributes.is_premium)) {
      const adloopTrackingConfig: DialogConfig = new AdloopTrackingSteppedPopinConf(null, dataSource).config;

      adloopTrackingConfig.data.inputData['data_set_id'] = this.appS.datasetID;

      this.dialog.open(AdloopTrackingSteppedComponent, adloopTrackingConfig);
    } else {
      // Opens the iframe
      this.dialog.open(IframeDialogComponent, {
        data: {
          inputData: {
            link: this.dataSourcesS.getSetupLink(dataSource)
          }
        },
        width: '800px',
        height: '600px',
        disableClose: false
      });
    }
  }

}
